import { useEffect, useState } from "react"
import Table from "react-bootstrap/esm/Table"
import { Link } from "react-router-dom"

export const ListCompany = () => {
  const [companies] = useState([])
  useEffect(() => {
    // getCompanies()

  }, [])
  return (
    <>
      <div className="d-flex justify-content-between mb-4">
        <div>
          <h2 className="mb-4">EMPRESAS CADASTRADAS</h2>
        </div>
        <div>
          <Link
            id="link-register-company"
            className="nav-link"
            to="/empresas/cadastro"
            style={{
              backgroundColor: "#30a151",
              display: "flex",
              cursor: "pointer",
              alignItems: "center",
              padding: "10px",
              borderRadius:"5px"
            }}
          >

            <span style={{color:"#FFFFFF", fontWeight:"normal"}}>
              CADASTRAR
            </span>
          </Link>
        </div>

      </div>
      <Table striped>
        <thead>
          <tr>
            <th>#</th>
            <th>Nome</th>
            <th>Nome Fantasia</th>
            <th>Telefone</th>
            <th>Email</th>
            <th>Plano</th>
            <th>Preço</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {companies.length > 0 ? companies.map((company: any, index) => (
            <tr key={index}>
              <td>{index + 1}</td>
              <td>{company.nome}</td>
              <td>{company.nomeFantasia}</td>
              <td>{company.telefone}</td>
              <td>{company.email}</td>
              <td>{company.plano}</td>
              <td>{company.preco}</td>
              <td>{company.status}</td>
            </tr>
          )) :
            <tr>
              <td colSpan={8} className="text-center">Nenhuma empresa cadastrada</td>
            </tr>}
        </tbody>
      </Table></>


  )
}